import en from './en.json';
import de from './de.json';
import sk from './sk.json';
import cs from './cs.json';

export const locales = {
  en,
  de,
  sk,
  cs
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧', country: 'International' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰', country: 'Slovensko' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿', country: 'Česko' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', country: 'Deutschland' }
];

export default locales;
